import * as yup from "yup";
import {string} from "yup";
import i18n from "i18next";
class RequestComment {
    constructor({
                    comment = '',
                } = {}) {
        this.comment = comment;
    }

    static getAttributes(filter = null, validationSchema = null ,optionsData = null) {
      
        // const completeSchema = yup.object().shape({
        //     comment: string().required(i18n.t('validationMessage.fieldRequired')),
        // });

        const attributes = {
            comment :{
                'label': i18n.t('modelLabel.comment'),
                'form': {
                    'type': 'textarea',
                    'placeholder': i18n.t('formPlaceholder.enterComment'),
                    //'validation': completeSchema.fields.comment,
                },
                'value': (item) => item.comment || "",
            },         
        }

        // if (validationSchema === true) {
        //     return completeSchema;
        // }

        return attributes;
    }
}
export default RequestComment;